/*
 * Responsive Layout helper
 */
window.ResponsiveHelper = (function ($) {
	// init variables
	var handlers = [],
		prevWinWidth,
		win = $(window),
		nativeMatchMedia = false;

	// detect match media support
	if (window.matchMedia) {
		if (window.Window && window.matchMedia === Window.prototype.matchMedia) {
			nativeMatchMedia = true;
		} else if (window.matchMedia.toString().indexOf("native") > -1) {
			nativeMatchMedia = true;
		}
	}

	// prepare resize handler
	function resizeHandler() {
		var winWidth = win.width();
		if (winWidth !== prevWinWidth) {
			prevWinWidth = winWidth;

			// loop through range groups
			$.each(handlers, function (index, rangeObject) {
				// disable current active area if needed
				$.each(rangeObject.data, function (property, item) {
					if (item.currentActive && !matchRange(item.range[0], item.range[1])) {
						item.currentActive = false;
						if (typeof item.disableCallback === "function") {
							item.disableCallback();
						}
					}
				});

				// enable areas that match current width
				$.each(rangeObject.data, function (property, item) {
					if (!item.currentActive && matchRange(item.range[0], item.range[1])) {
						// make callback
						item.currentActive = true;
						if (typeof item.enableCallback === "function") {
							item.enableCallback();
						}
					}
				});
			});
		}
	}
	win.bind("load resize orientationchange", resizeHandler);

	// test range
	function matchRange(r1, r2) {
		var mediaQueryString = "";
		if (r1 > 0) {
			mediaQueryString += "(min-width: " + r1 + "px)";
		}
		if (r2 < Infinity) {
			mediaQueryString +=
				(mediaQueryString ? " and " : "") + "(max-width: " + r2 + "px)";
		}
		return matchQuery(mediaQueryString, r1, r2);
	}

	// media query function
	function matchQuery(query, r1, r2) {
		if (window.matchMedia && nativeMatchMedia) {
			return matchMedia(query).matches;
		} else if (window.styleMedia) {
			return styleMedia.matchMedium(query);
		} else if (window.media) {
			return media.matchMedium(query);
		} else {
			return prevWinWidth >= r1 && prevWinWidth <= r2;
		}
	}

	// range parser
	function parseRange(rangeStr) {
		var rangeData = rangeStr.split("..");
		var x1 = parseInt(rangeData[0], 10) || -Infinity;
		var x2 = parseInt(rangeData[1], 10) || Infinity;
		return [x1, x2].sort(function (a, b) {
			return a - b;
		});
	}

	// export public functions
	return {
		addRange: function (ranges) {
			// parse data and add items to collection
			var result = { data: {} };
			$.each(ranges, function (property, data) {
				result.data[property] = {
					range: parseRange(property),
					enableCallback: data.on,
					disableCallback: data.off,
				};
			});
			handlers.push(result);

			// call resizeHandler to recalculate all events
			prevWinWidth = null;
			resizeHandler();
		},
	};
})(jQuery);

/*
 * jQuery Accordion plugin new
 */
(function (root, factory) {
	"use strict";
	root.SlideAccordion = factory(jQuery);
})(window, function ($) {
	"use strict";
	var accHiddenClass = "js-acc-hidden";

	function SlideAccordion(options) {
		this.options = $.extend(
			true,
			{
				allowClickWhenExpanded: false,
				activeClass: "active",
				opener: ".opener",
				slider: ".slide",
				animSpeed: 300,
				collapsible: true,
				event: "click",
				scrollToActiveItem: {
					enable: false,
					breakpoint: 767, // max-width
					animSpeed: 600,
					extraOffset: null,
				},
			},
			options
		);
		this.init();
	}

	SlideAccordion.prototype = {
		init: function () {
			if (this.options.holder) {
				this.findElements();
				this.setStateOnInit();
				this.attachEvents();
				this.makeCallback("onInit");
			}
		},

		findElements: function () {
			this.$holder = $(this.options.holder).data("SlideAccordion", this);
			this.$items = this.$holder.find(":has(" + this.options.slider + ")");
		},

		setStateOnInit: function () {
			var self = this;

			this.$items.each(function () {
				if (!$(this).hasClass(self.options.activeClass)) {
					$(this).find(self.options.slider).addClass(accHiddenClass);
				}
			});
		},

		attachEvents: function () {
			var self = this;

			this.accordionToggle = function (e) {
				var $item = jQuery(this).closest(self.$items);
				var $actiItem = self.getActiveItem($item);

				if (
					!self.options.allowClickWhenExpanded ||
					!$item.hasClass(self.options.activeClass)
				) {
					e.preventDefault();
					self.toggle($item, $actiItem);
				}
			};

			this.$items.on(
				this.options.event,
				this.options.opener,
				this.accordionToggle
			);
		},

		toggle: function ($item, $prevItem) {
			if (!$item.hasClass(this.options.activeClass)) {
				this.show($item);
			} else if (this.options.collapsible) {
				this.hide($item);
			}

			if (!$item.is($prevItem) && $prevItem.length) {
				this.hide($prevItem);
			}

			this.makeCallback("beforeToggle");
		},

		show: function ($item) {
			var $slider = $item.find(this.options.slider);

			$item.addClass(this.options.activeClass);
			$slider
				.stop()
				.hide()
				.removeClass(accHiddenClass)
				.slideDown({
					duration: this.options.animSpeed,
					complete: function () {
						$slider.removeAttr("style");
						if (
							this.options.scrollToActiveItem.enable &&
							window.innerWidth <= this.options.scrollToActiveItem.breakpoint
						) {
							this.goToItem($item);
						}
						this.makeCallback("onShow", $item);
					}.bind(this),
				});

			this.makeCallback("beforeShow", $item);
		},

		hide: function ($item) {
			var $slider = $item.find(this.options.slider);

			$item.removeClass(this.options.activeClass);
			$slider
				.stop()
				.show()
				.slideUp({
					duration: this.options.animSpeed,
					complete: function () {
						$slider.addClass(accHiddenClass);
						$slider.removeAttr("style");
						this.makeCallback("onHide", $item);
					}.bind(this),
				});

			this.makeCallback("beforeHide", $item);
		},

		goToItem: function ($item) {
			var itemOffset = $item.offset().top;

			if (itemOffset < $(window).scrollTop()) {
				// handle extra offset
				if (typeof this.options.scrollToActiveItem.extraOffset === "number") {
					itemOffset -= this.options.scrollToActiveItem.extraOffset;
				} else if (
					typeof this.options.scrollToActiveItem.extraOffset === "function"
				) {
					itemOffset -= this.options.scrollToActiveItem.extraOffset();
				}

				$("body, html").animate(
					{
						scrollTop: itemOffset,
					},
					this.options.scrollToActiveItem.animSpeed
				);
			}
		},

		getActiveItem: function ($item) {
			return $item.siblings().filter("." + this.options.activeClass);
		},

		makeCallback: function (name) {
			if (typeof this.options[name] === "function") {
				var args = Array.prototype.slice.call(arguments);
				args.shift();
				this.options[name].apply(this, args);
			}
		},

		destroy: function () {
			this.$holder.removeData("SlideAccordion");
			this.$items.off(
				this.options.event,
				this.options.opener,
				this.accordionToggle
			);
			this.$items.removeClass(this.options.activeClass).each(
				function (i, item) {
					$(item)
						.find(this.options.slider)
						.removeAttr("style")
						.removeClass(accHiddenClass);
				}.bind(this)
			);
			this.makeCallback("onDestroy");
		},
	};

	$.fn.slideAccordion = function (opt) {
		var args = Array.prototype.slice.call(arguments);
		var method = args[0];

		return this.each(function () {
			var $holder = jQuery(this);
			var instance = $holder.data("SlideAccordion");

			if (typeof opt === "object" || typeof opt === "undefined") {
				new SlideAccordion(
					$.extend(
						true,
						{
							holder: this,
						},
						opt
					)
				);
			} else if (typeof method === "string" && instance) {
				if (typeof instance[method] === "function") {
					args.shift();
					instance[method].apply(instance, args);
				}
			}
		});
	};
	(function () {
		var tabStyleSheet = $('<style type="text/css">')[0];
		var tabStyleRule = "." + accHiddenClass;
		tabStyleRule +=
			"{position:absolute !important;left:-9999px !important;top:-9999px !important;display:block !important; width: 100% !important;}";
		if (tabStyleSheet.styleSheet) {
			tabStyleSheet.styleSheet.cssText = tabStyleRule;
		} else {
			tabStyleSheet.appendChild(document.createTextNode(tabStyleRule));
		}
		$("head").append(tabStyleSheet);
	})();

	return SlideAccordion;
});

/*
 * jQuery Open/Close plugin
 */
(function ($) {
	function OpenClose(options) {
		this.options = $.extend(
			{
				addClassBeforeAnimation: true,
				hideOnClickOutside: false,
				activeClass: "active",
				opener: ".opener",
				slider: ".slide",
				animSpeed: 400,
				effect: "fade",
				event: "click",
			},
			options
		);
		this.init();
	}
	OpenClose.prototype = {
		init: function () {
			if (this.options.holder) {
				this.findElements();
				this.attachEvents();
				this.makeCallback("onInit", this);
			}
		},
		findElements: function () {
			this.holder = $(this.options.holder);
			this.opener = this.holder.find(this.options.opener);
			this.slider = this.holder.find(this.options.slider);
		},
		attachEvents: function () {
			// add handler
			var self = this;
			this.eventHandler = function (e) {
				e.preventDefault();
				if (self.slider.hasClass(slideHiddenClass)) {
					self.showSlide();
				} else {
					self.hideSlide();
				}
			};
			self.opener.on(self.options.event, this.eventHandler);

			// hover mode handler
			if (self.options.event === "hover") {
				self.opener.on("mouseenter", function () {
					if (!self.holder.hasClass(self.options.activeClass)) {
						self.showSlide();
					}
				});
				self.holder.on("mouseleave", function () {
					self.hideSlide();
				});
			}

			// outside click handler
			self.outsideClickHandler = function (e) {
				if (self.options.hideOnClickOutside) {
					var target = $(e.target);
					if (!target.is(self.holder) && !target.closest(self.holder).length) {
						self.hideSlide();
					}
				}
			};

			// set initial styles
			if (this.holder.hasClass(this.options.activeClass)) {
				$(document).on("click touchstart", self.outsideClickHandler);
			} else {
				this.slider.addClass(slideHiddenClass);
			}
		},
		showSlide: function () {
			var self = this;
			if (self.options.addClassBeforeAnimation) {
				self.holder.addClass(self.options.activeClass);
			}
			self.slider.removeClass(slideHiddenClass);
			$(document).on("click touchstart", self.outsideClickHandler);

			self.makeCallback("animStart", true);
			toggleEffects[self.options.effect].show({
				box: self.slider,
				speed: self.options.animSpeed,
				complete: function () {
					if (!self.options.addClassBeforeAnimation) {
						self.holder.addClass(self.options.activeClass);
					}
					self.makeCallback("animEnd", true);
				},
			});
		},
		hideSlide: function () {
			var self = this;
			if (self.options.addClassBeforeAnimation) {
				self.holder.removeClass(self.options.activeClass);
			}
			$(document).off("click touchstart", self.outsideClickHandler);

			self.makeCallback("animStart", false);
			toggleEffects[self.options.effect].hide({
				box: self.slider,
				speed: self.options.animSpeed,
				complete: function () {
					if (!self.options.addClassBeforeAnimation) {
						self.holder.removeClass(self.options.activeClass);
					}
					self.slider.addClass(slideHiddenClass);
					self.makeCallback("animEnd", false);
				},
			});
		},
		destroy: function () {
			this.slider.removeClass(slideHiddenClass).css({
				display: "",
			});
			this.opener.off(this.options.event, this.eventHandler);
			this.holder.removeClass(this.options.activeClass).removeData("OpenClose");
			$(document).off("click touchstart", this.outsideClickHandler);
		},
		makeCallback: function (name) {
			if (typeof this.options[name] === "function") {
				var args = Array.prototype.slice.call(arguments);
				args.shift();
				this.options[name].apply(this, args);
			}
		},
	};

	// add stylesheet for slide on DOMReady
	var slideHiddenClass = "js-slide-hidden";
	(function () {
		var tabStyleSheet = $('<style type="text/css">')[0];
		var tabStyleRule = "." + slideHiddenClass;
		tabStyleRule +=
			"{position:absolute !important;left:-9999px !important;top:-9999px !important;display:block !important}";
		if (tabStyleSheet.styleSheet) {
			tabStyleSheet.styleSheet.cssText = tabStyleRule;
		} else {
			tabStyleSheet.appendChild(document.createTextNode(tabStyleRule));
		}
		$("head").append(tabStyleSheet);
	})();

	// animation effects
	var toggleEffects = {
		slide: {
			show: function (o) {
				o.box.stop(true).hide().slideDown(o.speed, o.complete);
			},
			hide: function (o) {
				o.box.stop(true).slideUp(o.speed, o.complete);
			},
		},
		fade: {
			show: function (o) {
				o.box.stop(true).hide().fadeIn(o.speed, o.complete);
			},
			hide: function (o) {
				o.box.stop(true).fadeOut(o.speed, o.complete);
			},
		},
		none: {
			show: function (o) {
				o.box.hide().show(0, o.complete);
			},
			hide: function (o) {
				o.box.hide(0, o.complete);
			},
		},
	};

	// jQuery plugin interface
	$.fn.openClose = function (opt) {
		var args = Array.prototype.slice.call(arguments);
		var method = args[0];

		return this.each(function () {
			var $holder = jQuery(this);
			var instance = $holder.data("OpenClose");

			if (typeof opt === "object" || typeof opt === "undefined") {
				$holder.data(
					"OpenClose",
					new OpenClose(
						$.extend(
							{
								holder: this,
							},
							opt
						)
					)
				);
			} else if (typeof method === "string" && instance) {
				if (typeof instance[method] === "function") {
					args.shift();
					instance[method].apply(instance, args);
				}
			}
		});
	};
})(jQuery);

/*jshint browser:true */
/*!
* FitVids 1.1
*
* Copyright 2013, Chris Coyier - http://css-tricks.com + Dave Rupert - http://daverupert.com
* Credit to Thierry Koblentz - http://www.alistapart.com/articles/creating-intrinsic-ratios-for-video/
* Released under the WTFPL license - http://sam.zoy.org/wtfpl/
*
*/

;(function( $ ){

	'use strict';

	$.fn.fitVids = function( options ) {
	  var settings = {
		customSelector: null,
		ignore: null
	  };

	  if(!document.getElementById('fit-vids-style')) {
		// appendStyles: https://github.com/toddmotto/fluidvids/blob/master/dist/fluidvids.js
		var head = document.head || document.getElementsByTagName('head')[0];
		var css = '.fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}';
		var div = document.createElement("div");
		div.innerHTML = '<p>x</p><style id="fit-vids-style">' + css + '</style>';
		head.appendChild(div.childNodes[1]);
	  }

	  if ( options ) {
		$.extend( settings, options );
	  }

	  return this.each(function(){
		var selectors = [
		  'iframe[src*="player.vimeo.com"]',
		  'iframe[src*="youtube.com"]',
		  'iframe[src*="youtube-nocookie.com"]',
		  'iframe[src*="kickstarter.com"][src*="video.html"]',
		  'object',
		  'embed'
		];

		if (settings.customSelector) {
		  selectors.push(settings.customSelector);
		}

		var ignoreList = '.fitvidsignore';

		if(settings.ignore) {
		  ignoreList = ignoreList + ', ' + settings.ignore;
		}

		var $allVideos = $(this).find(selectors.join(','));
		$allVideos = $allVideos.not('object object'); // SwfObj conflict patch
		$allVideos = $allVideos.not(ignoreList); // Disable FitVids on this video.

		$allVideos.each(function(){
		  var $this = $(this);
		  if($this.parents(ignoreList).length > 0) {
			return; // Disable FitVids on this video.
		  }
		  if (this.tagName.toLowerCase() === 'embed' && $this.parent('object').length || $this.parent('.fluid-width-video-wrapper').length) { return; }
		  if ((!$this.css('height') && !$this.css('width')) && (isNaN($this.attr('height')) || isNaN($this.attr('width'))))
		  {
			$this.attr('height', 9);
			$this.attr('width', 16);
		  }
		  var height = ( this.tagName.toLowerCase() === 'object' || ($this.attr('height') && !isNaN(parseInt($this.attr('height'), 10))) ) ? parseInt($this.attr('height'), 10) : $this.height(),
			  width = !isNaN(parseInt($this.attr('width'), 10)) ? parseInt($this.attr('width'), 10) : $this.width(),
			  aspectRatio = height / width;
		  if(!$this.attr('name')){
			var videoName = 'fitvid' + $.fn.fitVids._count;
			$this.attr('name', videoName);
			$.fn.fitVids._count++;
		  }
		  $this.wrap('<div class="fluid-width-video-wrapper"></div>').parent('.fluid-width-video-wrapper').css('padding-top', (aspectRatio * 100)+'%');
		  $this.removeAttr('height').removeAttr('width');
		});
	  });
	};

	// Internal counter for unique video names.
	$.fn.fitVids._count = 0;

  // Works with either jQuery or Zepto
  })( window.jQuery || window.Zepto );
